var thumbnails = jQuery('.radios--swatch-button'); /* All product images */

window.initSwatch = function(container) {
  let parentContainer = document.querySelectorAll('.radios--main');
  if(container) {
    parentContainer = container.querySelectorAll('.radios--main')
  }
  
  parentContainer.forEach(swatch => {

  swatch.addEventListener('mouseenter', function(e) {
    var $this = $(this);
    $this.closest('.product-card--details').find('.radios--main').removeClass('add-active');
    $this.closest('.product-card--root').find('.grid-product__color-image').removeClass('is-active');
    $this.closest('.product-card--details').find('[data-price]').hide()
    
    var dataTargetInput = $this.find('input');
    var variantId = $(dataTargetInput).attr('data-variant-id');
    
    $this.addClass('add-active');
    $this.closest('.product-card--root').find('.grid-product__color-image--' + variantId).addClass('is-active');
    $this.closest('.product-card--details').find(`.price--${variantId}`).show();
    

  });
  swatch.addEventListener('mouseleave', function(e) {
    var $this = $(this);
    var dataTargetInput = $this.find('input');
    var variantId = $(dataTargetInput).attr('data-variant-id');
    $this.closest('.product-card--details').find('.radios--main').removeClass('add-active');
    $this.closest('.product-card--root').find('.grid-product__color-image').removeClass('is-active');
    $this.removeClass('add-active');
    var checkInput = $this.closest('.radios--container');
    let checkInputValue = $(checkInput).find('input:checked').attr('data-variant-id');
    if(checkInputValue != undefined) {
      $this.closest('.product-card--details').find('[data-price]').hide()
      $('.grid-product__color-image--' + checkInputValue).addClass('is-active');
      $('.price--' + checkInputValue).show();
    } else {
      $this.closest('.product-card--details').find('[data-price]').hide()
      $this.closest('.product-card--details').find('[data-price]:eq(0)').show();
    }
    
  });
  swatch.addEventListener('click', function(e) {
    var $this = $(this);
    var dataTargetInput = $this.find('input');

    console.log($this.closest('.product-form--options').find('[data-ul-var]').length)
    if ($this.closest('.product-form--options').find('[data-ul-var]').length > 0) {
      $(`[data-ul-var] [data-value="${$(dataTargetInput).val()}"]`).trigger('click');
      
      $('[data-ul-var]').children('li:not(.init)').hide();
      $('[data-ul-var]').removeClass('rotate');
      $this.closest('.product-form--option').find('.radios--option-current').text($(dataTargetInput).val());
      // $(`.product-form--variant-select option[data-title="${$(dataTargetInput).val()}"]`).closest('select').val($(`.product-form--variant-select option[data-title="${$(dataTargetInput).val()}"]`).val()).trigger('change');
    }

    if ($this.closest('.product-form--options').find('[data-ul-var]').length == 0) {
      var variantId = $(dataTargetInput).attr('data-variant-id');
      $('.grid-product__color-image').removeClass('is-load');
      $(dataTargetInput).prop("checked", true);
      $(dataTargetInput).addClass('humble');
      $this.closest('.product-card--details').find('.radios--main').removeClass('add-active');
      $this.closest('.product-card--root').find('.grid-product__color-image').removeClass('is-active');
      $this.closest('.product-card--details').find('[data-price]').hide()

      $this.addClass('add-active');
      $this.closest('.product-card--root').find('.grid-product__color-image--' + variantId).addClass('is-active');
      $this.closest('.product-card--details').find(`.price--${variantId}`).show();
    }

    });
  });
} 

window.initSwatch()




// Set up the observer
const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
            if (node.nodeType === 1) { // Element node
                if (
                    node.classList.contains('radios--main') ||
                    node.querySelector('.radios--main')
                ) {
                    window.initSwatch(node.parentElement);
                    return; // Early exit — one call is enough
                }
            }
        }
    }
});

// Start observing the document body
observer.observe(document.body, {
    childList: true,
    subtree: true
});




